import {ChangeDetectorRef, Component, ViewEncapsulation} from '@angular/core';
import {UserInfoStorageService} from '../../../services/auth/user-info-storage.service';
import {CrystalClearFrontUrl} from '../../../shared/pages/crystal-clear-front-url';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderActionService} from '../../../services/header-action.service';
import {ToastService} from '../../../services/toast-service';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CrystalClearFrontUrlTools} from "../../../shared/pages/crystal-clear-front-url-tools";
import {ThemeService} from "../../../services/tools/theme.service";
import {HeaderMenuBaseComponent} from "./header-menu-base.component";
import {CcStorageService} from "../../../services/common/cc-storage.service";
import {AppConfigService} from "../../../services/app-config.service";
import {CrystalClearFrontUrlSupport} from "../../../shared/pages/crystal-clear-front-url-support";


@Component({
  selector: 'app-header-menu-lite',
  templateUrl: './header-menu-lite.component.html',
  styleUrls: ['./header-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    TranslateService,
  ]
})
export class HeaderMenuLiteComponent extends HeaderMenuBaseComponent {

  showHealthCheck: boolean = false;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              authService: UserInfoStorageService,
              router: Router,
              headerActionService: HeaderActionService,
              route: ActivatedRoute,
              toastService: ToastService,
              translateService: TranslateService,
              storageService: CcStorageService,
              themeService: ThemeService,
              public appConfigService: AppConfigService) {
    super(cdref,messageService, authService, router, headerActionService, route, toastService, translateService, storageService, themeService);
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.isAdmin()) {
      this.showHealthCheck = this.appConfigService.healthEnabledForAdmin;
    } else {
      this.showHealthCheck = this.appConfigService.healthEnabled;
    }
  }

  protected initMenuItems() {
    if (this.userInfo) {
      this.menuBarItemsRight = [
        this.toMenuItem(CrystalClearFrontUrlTools.TOOLS, true,
          [
            this.toMenuItem(CrystalClearFrontUrl.SECURITY_USER, false),
            this.toMenuItem(CrystalClearFrontUrl.SECURITY_USER_GROUP, false),
            this.toMenuItem(CrystalClearFrontUrlTools.TOOLS_NOTIFY, false, [], this.appConfigService.notificationEnabled),
            this.toMenuItem(CrystalClearFrontUrlTools.TOOLS_SCHEDULER, false, [], this.appConfigService.schedulerEnabled),
            this.toMenuItem(CrystalClearFrontUrlSupport.SUPPORT_SYNC, false, [], this.appConfigService.supportEnabled),
            this.toMenuItem(CrystalClearFrontUrlSupport.SUPPORT_TOC, false, [], this.appConfigService.supportEnabled),
          ]),
      ];
    }
  }
}

